import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class SidenavMenuConstant {

  public static sidenavMenu = [
    {
      menuTitle: 'Failure Dashboard',
      imagePath: 'assets/images/dashboard-RC.svg',
      route: 'failure/fdashboard',
      isEnabled: false, isDisabled: false
    },
    {
      menuTitle: 'SINCS Dashboard',
      imagePath: 'assets/images/dashboard-SINCS.svg',
      route: 'failure/sdashboard',
      isEnabled: false, isDisabled: false
    },
    {
      menuTitle: 'Create Failure',
      imagePath: 'assets/images/dashboard-Failure.svg',
      route: 'failure/fcreation',
      isEnabled: false, isDisabled: false
    },
    {
      menuTitle: 'Reminders & Notifications',
      imagePath: 'assets/images/dashboard-bell.svg',
      route: 'user/ualert',
      isEnabled: false, isDisabled: false
    },
    {
      menuTitle: 'Admin',
      imagePath: 'assets/images/dashboard-setting.svg',
      route: 'admin/amanagement',
      isEnabled: false, isDisabled: false
    },
  ];

}
